import React, { useState } from "react";
import { errorHandler } from "../../helpers/helpers";
import styles from "./Home.module.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { UseToast } from "../../components/context/ToastContext";
import axios from "axios";
import { handleCSVExport } from "../../helpers/exportHelper";
import moment from "moment";
import { API } from "../../utility/Api";

export default function Home() {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selectedApp, setSelectedApp] = useState();
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedAppType, setSelectedAppType] = useState("");
  const [jobId, setJobId] = useState();
  const [cancelToken, setCancelToken] = useState(null);
  let s3Logs = [];
  const { setMainMessage, appNames, appRegions, appTypes } = UseToast();

  const handleAppChange = (event) => setSelectedApp(event.target.value);

  const handleRegionChange = (event) => setSelectedRegion(event.target.value);

  const handleAppTypeChange = (event) => setSelectedAppType(event.target.value);

  const handleJobIdChange = (event) => setJobId(event.target.value);

  const handleReset = () => {
    setSelectedRegion("");
    setSelectedAppType("");
    setJobId("");
  };

  const handleApply = () => {
    s3Logs = [];
    getS3Logs();
  };

  const getS3Logs = (nextPageToken = null) => {
    if (selectedAppType && selectedRegion && jobId.length > 0) {
      if (cancelToken) cancelToken.cancel("Canceling previous request");

      const newCancelToken = axios.CancelToken.source();
      setCancelToken(newCancelToken);
      getS3LogResults(newCancelToken, nextPageToken);
    }
  };

  const getS3LogResults = async (newCancelToken, nextPageToken) => {
    setIsLoading(true);
    //eslint-disable-next-line
    AP.context.getToken(async function (token) {
      const payload = {
        app: selectedApp,
        appType: selectedAppType,
        nextPageToken: nextPageToken,
        jobId: jobId,
      };
      const endpoint = `getS3LogResults?region=${selectedRegion}`;
      try {
        const response = await API.post(`${endpoint}`, payload, {
          headers: {
            Authorization: `JWT ${token}`,
          },
          cancelToken: newCancelToken.token ? newCancelToken.token : "",
        });

        s3Logs.push(...response.data.logs);
        if (response.data.nextPageToken) getS3Logs(response.data.nextPageToken);
        else downloadLogs();
      } catch (error) {
        setIsError(true);
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setIsLoading(false);
      }
    });
  };

  const csvHeaders = [
    { key: "timestamp", displayLabel: "Timestamp" },
    { key: "message", displayLabel: "Message" },
  ];
  const downloadLogs = () => {
    s3Logs.map(
      (log) =>
        (log.timestamp = moment
          .unix(log.timestamp?.toString().slice(0, -3))
          .format("ddd ,DD MMM YYYY hh:mm:ss "))
    );

    handleCSVExport(
      `Revyz_${selectedAppType}_${jobId}`,
      csvHeaders,
      s3Logs,
      `${selectedApp}_${selectedRegion}_${selectedAppType}_job_${jobId}`
    );
    setIsLoading(false);
  };

  return (
    <div className={styles.homeContainer}>
      <div className={styles.homeTopForm}>
        <div className={styles.rightFilter}>
          <FormControl fullWidth size="small" sx={{ m: 0 }}>
            <InputLabel
              htmlFor="select-app"
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              Select app
            </InputLabel>
            <Select
              labelId="select-app"
              id="select-app"
              label="select-app"
              value={selectedApp}
              onChange={handleAppChange}
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              {appNames.map((name, index) => (
                <MenuItem key={index} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" sx={{ m: 0 }}>
            <InputLabel
              htmlFor="select-region"
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              Select region
            </InputLabel>
            <Select
              labelId="select-region"
              id="select-region"
              label="select-region"
              value={selectedRegion}
              onChange={handleRegionChange}
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              {appRegions.map((region, index) => (
                <MenuItem key={index} value={region}>
                  {region}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" sx={{ m: 0 }}>
            <InputLabel
              htmlFor="select-type"
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              Select app type
            </InputLabel>
            <Select
              labelId="select-type"
              id="select-type"
              label="select-type"
              value={selectedAppType}
              onChange={handleAppTypeChange}
              sx={{ fontSize: ".875rem", fontWeight: 600 }}
            >
              {appTypes.map((apptype, index) => (
                <MenuItem key={index} value={apptype}>
                  {apptype}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" sx={{ m: 0 }}>
            <TextField
              required
              label="Job Id"
              id="job-id"
              value={jobId}
              onChange={handleJobIdChange}
              type="search"
            />
          </FormControl>

          <Button variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <LoadingButton
            variant="contained"
            loading={isLoading}
            onClick={handleApply}
            disabled={
              !(selectedAppType && selectedRegion && jobId && jobId.length > 0)
            }
          >
            Apply
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
